import { 
  Database, 
  FileText, 
  MessageCircle, 
  Users,
  Zap,
  Home,
  Search,
  CreditCard,
  Activity,
  Settings,
  LogOut,
  User,
  ChevronDown,
  Menu,
  X
} from 'lucide-react';

export const ICONS = {
  Database,
  FileText,
  MessageCircle,
  Users,
  Zap,
  Home,
  Search,
  CreditCard,
  Activity,
  Settings,
  LogOut,
  User,
  ChevronDown,
  Menu,
  X
};

export const getIcon = (iconName) => {
  return ICONS[iconName] || Database; // Fallback para Database se o ícone não for encontrado
};

